
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import useTranslation from '../../Hooks/UseTranslation';
import moment from 'moment';
import KanbanTaskProgress from './KanbanTaskProgress';
import KanbanTaskWorksList from './KanbanTaskWorksList';
import KanbanTaskResponsibles from './KanbanTaskResponsibles';

import './KanbanTaskCard.scss'

interface Props {
  task: any;
  responsibles: any;

  onClick: (task_id: string) => void;
}

const KanbanTaskCard = (props: any) => {

  const { t } = useTranslation();

  const {
    task,
    responsibles,
    onClick
  } = props

  const startDate = moment(task.startsAt).format('DD-MM-YYYY')
  const endDate = moment(task.endsAt).format('DD-MM-YYYY')

  const days = moment(task.endsAt).diff(moment(task.startsAt), 'days') + 1

  const [ restrictions, setRestrictions ] = useState('')

  const getRestrictions = (): any => {

    let checked = 0
    let all = 0

    if (task.restrictions.length) {

      all += task.restrictions.length

      task.restrictions.forEach((restriction: any) => {

        if (restriction.checked) {

          checked += 1
        }
      })
    }

    if (all === 0) {

      return ''
    }

    return `${checked}/${all}`
  }

  useEffect(() => {

    setRestrictions(getRestrictions())
  }, [ task.subTasks ])

  return (
    <Card
      className={`kanban-task-card`}
      onClick={() => onClick(task._id)}
    >
      {task.colorCode && (
        <div className="kanban-task-card-color-code" style={{ backgroundColor: task.colorCode.color }}></div>
      )}
      <div className="kanban-task-card-header">
        <div className="task-name">{task.name}</div>
        <div className="task-position">{task.position}</div>
      </div>
      <div className="kanban-task-card-dates">
        <div className="task-dates">
          {startDate}
          {(task.type !== 'hito' && task.type !== 'reunion') && (
            <>
              {' '}al {endDate}
            </>
          )}
        </div>
        {task.type !== 'hito' && task.type !== 'reunion' && (
          <div className="task-days">
            {days} días
          </div>
        )}
      </div>
      {task.type !== 'hito' && task.type !== 'reunion' && (
        <KanbanTaskProgress percentage={task.progress} status={task.status} />
      )}
      {!task.hasSubTasks && task.restrictions.length > 0 && (
        <div style={{ marginBottom: '.25rem'}}>
          {t('TASK_CARD:Constraints')} ({restrictions})
        </div>
      )}
      {task.hasSubTasks && (
        <KanbanTaskWorksList
          works={task.subTasks || []}
          onSelectWork={onClick}
        />
      )}
      <div className="task-footer">
        <div className="left">
          {task.comments.length > 0 && (
            <>
              {task.comments.length} {t('TASK_CARD:Comment')}{task.comments.length === 1 ? '' : 's'}
            </>
          )}
        </div>
        <div className="right">
          <KanbanTaskResponsibles
            responsibles={task.responsibles}
          />
        </div>
      </div>
    </Card>
  )
}

export default KanbanTaskCard
